import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import Routes from './Routes';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <Routes />
      </div>
    </HelmetProvider>
  );
}

export default App;
